import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useSession } from '../lib/session'

/**
 * Route guard for /op and /admin.
 *
 * This is a *convenience*, not a control. Every protected endpoint checks the role server-side
 * (08 §3); hiding a screen the API would refuse anyway just avoids showing an operator a page
 * full of 403s.
 */
export function RequireStaff({ children, role }: { children: ReactNode; role?: 'admin' }) {
  const { identity, status } = useSession()

  if (status === 'idle' || status === 'loading') {
    return <p className="mx-auto max-w-5xl px-5 py-14 text-muted">Checking your session…</p>
  }
  if (identity?.principal !== 'staff') {
    return <Navigate to="/staff/login" replace />
  }
  if (role === 'admin' && identity.role !== 'admin') {
    return (
      <div className="mx-auto max-w-2xl px-5 py-14">
        <h1 className="text-3xl">Not your area</h1>
        <p className="mt-4">That section is admin-only.</p>
      </div>
    )
  }
  return <>{children}</>
}
